import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  refreshComponent,
  refreshQuantities,
} from 'modules/quotes/quoteItems/data/sagas';
import { getQuoteItemFromComponentId } from 'modules/quotes/quoteItems/data/selectors';

import partService from 'services/partService';

import { customAttrsModal, updateCustomAttrs, types } from './actions';
import { getComponentId, getPartUuid } from './reducer';

export default function* root() {
  yield takeLatest(types.CUSTOM_ATTRS_MODAL_OPEN, watchOpenCustomAttrsModal);
  yield takeLatest(types.UPDATE_CUSTOM_ATTRS_REQUEST, watchUpdateCustomAttrs);
}

function* watchOpenCustomAttrsModal(action) {
  const { payload } = action;
  const { partUuid } = payload;

  try {
    const response = yield call(partService.getForBAQ, partUuid);
    yield put(
      customAttrsModal.initFinish({ customAttrs: response.customAttrs || [] }),
    );
  } catch (error) {
    console.error(error);
    yield put(customAttrsModal.initFinish({ customAttrs: [] }));
  }
}

function* watchUpdateCustomAttrs(action) {
  const { payload } = action;
  const { customAttrs } = payload;
  const partUuid = yield select(getPartUuid);
  const componentId = yield select(getComponentId);

  try {
    yield call(partService.updateForBAQ, partUuid, { customAttrs });
    // the custom attribute update endpoint doesnt actually recalculate the
    // component, so we call for that here on the active component
    yield call(refreshComponent, componentId, { refresh: true });

    // refresh root component quantities if necessary
    const quoteItem = yield select(getQuoteItemFromComponentId, componentId);
    if (quoteItem?.rootComponent != componentId) {
      yield call(refreshQuantities, quoteItem?.rootComponent);
    }

    yield put(updateCustomAttrs.success());
    yield put(customAttrsModal.close());
  } catch (error) {
    yield put(updateCustomAttrs.error(error));
  }
}
